"use client";

export function CurrentYear(props: React.HTMLAttributes<HTMLElement>) {
  return <span {...props}>{new Date().getFullYear()}</span>;
}
